export default "__VITE_ASSET__d4182b10__"